import * as React from 'react';
import classNames from 'classnames';
export const PrettyLabel = ({ color, icon, children, baseId, }) => (React.createElement("div", { className: classNames('state', {
        [`p-${color}`]: color,
    }) },
    icon,
    React.createElement("label", { htmlFor: baseId }, children)));
PrettyLabel.displayName = 'Pretty.Label';
